import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { map, catchError } from 'rxjs/operators'
import { v4 as SessionID } from 'uuid';

@Injectable({
  providedIn: 'root'
})
export class CustomerService {

  // public _Action: IAction;
  public _CustomerService = environment.CustomerService;
  public _httpOptions;
  public sessionId : string;
  // this.sessionId = SessionID();
constructor(private http: HttpClient) {
  this.sessionId = sessionStorage["SessionId"]
  this._httpOptions = {
    headers: new HttpHeaders({ 'SessionId':this.sessionId })
  };
  console.log(this._httpOptions)
}


GetPageInitializeDetails(): Observable < any > {
  var Query = this._CustomerService ;
  // console.log(Query);
  return this.http.get<{ data: any }>(Query,this._httpOptions);
}
InsertCustomer(customer: object) {
  
  // console.log("Create");
  var Query = this._CustomerService;
  return this.http.post<{ data: any }>(Query, customer,this._httpOptions);
}
UpdateCustomer(customer: object) {
  
  // console.log("Update");
  var Query = this._CustomerService;
  // console.log(Query);
  return this.http.put<{ data: any }>(Query, customer,this._httpOptions);
}
GetAll()
{
  var Query = this._CustomerService + '/GetAll';
  // console.log("temp",Query+  this.sessionId);
  return this.http.get<{ data: any }>(Query,this._httpOptions).pipe(map(data => {
    const resultJSON = JSON.parse(JSON.stringify(data));
    // console.log(resultJSON);
    return data;
  }));
}
VerifyCustomer(customer: object) {
  
  // console.log("Update");
  var Query = this._CustomerService + '/VerifyCustomer';
  // console.log(Query);
  return this.http.post<{ data: any }>(Query, customer,this._httpOptions);
}
}
